import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Sales is still the most important role in every business." />

      <nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/&amp;title=Sales%20is%20still%20the%20most%20important%20role%20in%20every%20business.&amp;summary=Sales%20is%20still%20the%20most%20important%20role%20in%20every%20business.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20is%20still%20the%20most%20important%20role%20in%20every%20business.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20is%20still%20the%20most%20important%20role%20in%20every%20business.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-success-thumbs-up.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>Sales careers</h3>
                        <h1>Sales is still the most important role in every business.</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>1 September 2016</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Despite the conjecture, sales is still the most important role in every business.</h3>
<p>In 2015, Forester Research made a bold proclamation that was heard all around the world - that there is a big ‘cull’ coming to the sales profession. </p><p>Since 2015, we have definitely witnessed a massive loss of sales roles in some industries however, we are also seeing a corresponding rise in sales roles in other industries. Not to mention a massive rise in inside sales and customer success roles across the board. </p><p>Putting aside the actual stats on whether sales roles are expanding or contracting, I simply want to make the point that there is still no other function that is more important in every business than the role of the sales. </p><p>Let’s consider a few facts:</p>
<div className="rich-text"><h3><strong>1) Product-Market Fit – and the conduit between both.</strong></h3><p>It doesn’t matter if you’re selling a product or a service, you need to understand and research how much demand is in the market, and how (and when) that demand is evolving. Truly effective sales &amp; marketing teams will not only communicate and sell the value of the firm’s products to target customers, but they will also continuously collect, synthesise and disseminate the critical market intelligence that will help the firm innovate and define (and re-define) the business strategy. Understanding the market, and decisions about product-market fit MUST begin with those closest to the coal face – the sales people. </p><h3><strong>2) Cash flow is the 'life-blood' of every business.</strong></h3><p>Cash-flow management has always been critical to business sustainability and this point resonates very loudly with me with due to a career focused on revenue generation activities, and the effect that the top-line always has on the bottom line. There is no other department or business function that has a greater impact on the development of the all-important cash flows than the sales (and marketing) department. Yet again reinforcing the tremendous importance of the role that sales people play in executing the business plan.   </p><h3> <strong>3) All business planning begins and ends with the sales forecast.</strong></h3><p>One of the key aims of senior management is to try, where possible, to increase control and predictability of the business. Almost all operational planning begins and ends with the budgeting process, and regardless of which type of budgeting model a business utilises (traditional, zero-based, rolling, quarterly, annual) all budgets are derived from the <strong>sales forecast</strong>. That is, how many units can be sold during the period? And at what price? The combination of these two questions is what constitutes the ‘top-line’ revenue projection, and this number effectively dictates how the entire business will be planned and operated throughout the ensuing period. Therefore, it is difficult to find a more important role than that of the sales people (moreover, the sales leader) in ensuring that the sales revenue forecast is at least somewhat accurate, enabling the entire business to be planned appropriately.</p></div>
<img alt="Communicating value" className="img-responsive" height="352" src="../../../media/images/AAEAAQAAAAAAAAg5AAAAJDgxZGRiMmI1LTE4MjAtNGNiZS.width-647.png" width="647"/>

<div className="rich-text"><h3><strong>4) Communicating value from the business to the market (and vice versa):</strong></h3><p>Businesses are always striving to bring new value to their customers. However, all value creation and innovation must be constantly sanity checked against evolving customer needs. Ideas about what might be valuable in the future (unanticipated products) more often than not stems from customer engagements, and this highlights the importance of open and ongoing customer dialogue. Deep engagement with the target market is yet another example of the importance of the sales function in providing business with those vital customer touch points for important feedback. This critical bi-directional flow of information between market and business requires that sales people do NOT overlook one of the most important elements of their role: feeding market-based <a href="http://bit.ly/1WNcx9i">intelligence back into the business</a>. Much room for improvement here!</p><h3><strong>5) "Nothing happens until someone sells something" (Henry Ford).</strong></h3><p>If you buy into the 4 points above (and please let me know if you don’t?) then broadly speaking there are actually only two roles across every business, in every industry, globally. If you are not a sales person then you are sales support. That is, your role exists to support sales. I can already sense people bristling at that comment, but like it or not, every other business function is redundant if the sales team fails to sell and generate the all-important cash flows.</p><p>This point was brought home to me in one of my early roles as an Account Manager working with a global enterprise software vendor. I will never forget attending a global Sales Kick-Off Conference back in 2001. The business had been through a tough couple of years and sales performance was down across the board. The CEO opened the conference on the very first morning with the following demand: <strong><em>“everyone in the room that carries a quota please stand up”.</em></strong> I sheepishly stood up, along with the rest of my sales co-workers, thinking that we were about to cop a serious blast from the CEO about the poor sales numbers. Instead the CEO went on to say something that had a profound effect on me. He said, “<em>now for all of you folks that remain seated </em>(pre-sales, marketing, HR, Finance, operations etc)<em> your sole purpose in this business is to support the people that are standing up – your roles only exist to support the sales people – so make sure that you take a look around this room at the people that are standing up, and start supporting them in everything that you do”.</em> I was both dumbfounded and at the same time delighted. Finally, a senior leader that understood the importance of having the entire organisation focused around sales success – which is really just a by-product of customer success.</p><p>So despite some the doom and gloom surrounding the sales profession right now, the role of the sales person as the conduit between the business and its various markets is just as critical today as it has ever been. Yes, the role is now undergoing a transformation to meet changing buyer behaviour, and yes, we sales people need to step up and adapt. </p><p>For those that do embrace the new world order the future will be just as rewarding as the past, but let me be clear, (and to borrow a line from best-selling author Marshall Goldsmith):</p></div>
<aside className="pull-quote">
    <blockquote>
        <p>&quot;what got you here today, won’t get you there tomorrow”.</p>
    </blockquote>
</aside>



        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/&amp;title=Sales%20is%20still%20the%20most%20important%20role%20in%20every%20business.&amp;summary=Sales%20is%20still%20the%20most%20important%20role%20in%20every%20business.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20is%20still%20the%20most%20important%20role%20in%20every%20business.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20is%20still%20the%20most%20important%20role%20in%20every%20business.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-still-most-important-role-every-business/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/7-laws-sales-success" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-ideas-announcement.jpg" className="card__image" height="404" src="../../../media/images/article-ideas-announcement_6oOJESq.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Sales careers</p>
                        <h3 className="card__title"><strong>The 7 Laws of Sales Success</strong></h3>
                    </header>
                    <p>There are certain &quot;Laws&quot; of the universe which successful people often leverage, and today&#39;s&#39; sales people must learn to embrace some of these important laws to ensure future sales success.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-outreach-destroying-your-career" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-challenge-yell.jpg" className="card__image" height="404" src="../../../media/images/article-challenge-yell_YbkW7pV.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Sales careers</p>
                        <h3 className="card__title"><strong>Is sales Outreach destroying your Career?</strong></h3>
                    </header>
                    <p>If you are still performing 20th century outreach tactics like &quot;cold calling&quot; then you are not just destroying your own career, but you are also destroying your employers brand and therefore their business.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/extrovert-introvert-rethinking-sales-priorities" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-challenge-juggle.jpg" className="card__image" height="404" src="../../../media/images/article-challenge-juggle_PUKUKDN.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Sales careers</p>
                        <h3 className="card__title"><strong>From extrovert to introvert: Rethinking sales priorities</strong></h3>
                    </header>
                    <p>What is the profile of a modern sales person?

This article was written by Graham Hawkins and it first appeared on the Salesforce Blog in July 2018:</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>
      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 